import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchPagination, SearchResults } from '@uncinc/react-searchkit';

import { SearchTeamHit } from '../types';
import HighlightedProfiles from '../../HighlightedProfiles';
import SearchErrorState from '../../Search/ErrorState';

const SearchTeamResults: React.FC = () => {
  const { t } = useTranslation();

  const classNames = c('SearchTeam__Results');

  return (
    <div className={classNames}>
      <h2>{t('components.search_team.results')}</h2>
      <SearchErrorState>
        <SearchResults
          renderItem={(hit: SearchTeamHit) => {
            return (
              <div className="SearchTeam__Result">
                <HighlightedProfiles.Profile
                  name={hit.field_full_name[0]}
                  info={hit.field_function ? hit.field_function.join(', ') : ''}
                  picture={hit.image_style_uri && (
                    <img src={hit.image_style_uri[0]} alt={hit.field_full_name[0]} />
                  )}
                  email={hit.field_email_address?.[0]}
                  tel={hit.field_telephone?.[0]}
                />
              </div>
            );
          }}
        />
        <div className="mt-4">
          <SearchPagination
            previousLabel={t('buttons.previous')}
            nextLabel={t('buttons.next')}
          />
        </div>
      </SearchErrorState>
    </div>
  );
};

export default SearchTeamResults;
